import { useState } from "react";

const ConditionalInput = (props) => {

    const currValue = props.currValue;
    const currCheck = props.currCheck;

    const [checked, setChecked] = useState(false);

    return [
        <tr key="row-checkbox">
        <td>Notifiche</td>
        <td>
            <input
            onChange={() => setChecked(prev => !prev)}
            type="checkbox"
            name="host_notify"
            id="host_notify"
            defaultChecked={currCheck}
            />
        </td>
        </tr>,
        <tr key="row-input">
        <td>Mail notifiche</td>
        <td>
            <input
            style={{ width: '95%' }}
            disabled={!checked}
            type="text"
            name="host_recipients"
            id="host_recipients"
            defaultValue={currValue}
            />
            <span style={{textAlign: 'left', marginLeft: '6px', marginRight: '100%', marginTop: '5px', fontSize: '15px'}}>Usa <b>,</b> per una lista di indirizzi </span>
        </td>
        </tr>,
    ];
};

export default ConditionalInput;